<template>
  <b-nav-item @click="openWhatsNew">
    <b-button
      id="whats-new-btn"
      class="btn-icon"
      variant="flat"
      style="padding: 0"
    >
      <feather-icon size="21" icon="GiftIcon" />
    </b-button>
    <b-tooltip
      target="whats-new-btn"
      title="O que há de novo"
      placement="top"
      boundary="viewport"
    />
  </b-nav-item>
</template>

<script>
import { BNavItem, BButton, BTooltip } from "bootstrap-vue";
import { mapActions } from "vuex";
import { useToast } from "vue-toastification/composition";
import ToastificationContent from "@core/components/toastification/ToastificationContent";
import * as types from "@/modules/whats-new/store/types";

export default {
  components: {
    BNavItem,
    BButton,
    BTooltip,
  },
  setup() {
    return { toast: useToast() };
  },
  methods: {
    ...mapActions({
      openModal: types.OPEN_WHATS_NEW_MODAL,
    }),
    openWhatsNew() {
      this.openModal()
        .then((resp) => {
          if (!resp.data || !resp.data.id) {
            this.toast({
              component: ToastificationContent,
              props: {
                title: "Você está em dia!",
                text: "Nenhuma novidade publicada por enquanto.",
                icon: "GiftIcon",
                variant: "info",
              },
            });
          }
        })
        .catch(() => {
          this.toast({
            component: ToastificationContent,
            props: {
              title: "Oops!",
              text: "Não foi possível abrir as novidades. Entre em contato com o setor de TI.",
              icon: "AlertTriangleIcon",
              variant: "danger",
            },
          });
        });
    },
  },
};
</script>
